import React from 'react';

interface NoDigitalLoadingModalProps {
  isOpen: boolean;
  message: string;
  pleaseWaitMessage?: string;
}

export const NoDigitalLoadingModal: React.FC<NoDigitalLoadingModalProps> = ({
  isOpen,
  message,
  pleaseWaitMessage = "Por favor, espera mientras procesamos tu solicitud..."
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-sm w-full mx-4 text-center">
        <div className="mb-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {message}
        </h3>
        <p className="text-sm text-gray-600">
          {pleaseWaitMessage}
        </p>
      </div>
    </div>
  );
};